import React from 'react';
import { ImageLoader } from '../ImageLoader';
import { MEDIA_VARIANTS } from '../../../media';
import Icon from '../../../ui/Icon';

function RegionPanelComponent({
  region,
  currentAction,
}) {
  const description = region?.description || region?.flavourText || 'Local survival odds remain statistically impolite.';
  const threat = region?.threatLevel || region?.difficulty || 'Unrated';
  const minimumEnemyLevel = Number(
    region?.minimumEnemyLevel ?? region?.MinimumEnemyLevel ?? region?.enemyLevel,
  );
  const maximumEnemyLevel = Number(
    region?.maximumEnemyLevel ?? region?.MaximumEnemyLevel ?? region?.enemyLevel,
  );
  const enemyLevelRange = Number.isFinite(minimumEnemyLevel)
    && minimumEnemyLevel > 0
    && Number.isFinite(maximumEnemyLevel)
    && maximumEnemyLevel > 0
    ? minimumEnemyLevel === maximumEnemyLevel
      ? `Level ${minimumEnemyLevel}`
      : `Levels ${minimumEnemyLevel}–${maximumEnemyLevel}`
    : '';
  const flatRegen = Number(region?.hpRegenFlatPerMinute);
  const percentRegen = Number(region?.hpRegenPercent);
  const regionalRegen = [
    Number.isFinite(flatRegen) && flatRegen !== 0
      ? `${flatRegen > 0 ? '+' : ''}${flatRegen} HP/min`
      : '',
    Number.isFinite(percentRegen) && percentRegen !== 0
      ? `${percentRegen > 0 ? '+' : ''}${percentRegen}%`
      : '',
  ].filter(Boolean).join(' · ');
  return (
    <div className="region-panel">
      <div className="region-panel__header">
        <div className="region-panel__art">
          {(region?.imageId || region?.animatedMediaId || region?.animatedImageId) ? (
            <ImageLoader
              className="region-panel__image"
              imageId={region.imageId}
              animatedMediaId={region.animatedMediaId || region.animatedImageId}
              variant={MEDIA_VARIANTS.REGION}
              posterVariant={MEDIA_VARIANTS.REGION_POSTER}
              aspectRatio="16 / 9"
              alt=""
            />
          ) : (
            <div className="region-panel__placeholder" aria-hidden="true"><Icon name="region" size={36} /></div>
          )}
        </div>
        <div className="region-panel__meta">
          <div className="region-panel__name">{region?.name || 'Unknown Region'}</div>
        </div>
      </div>
      <p className="region-panel__description">{description}</p>
      <div className="region-panel__facts">
        <div className="region-panel__fact">
          <span className="region-panel__fact-label">Current action</span>
          <span className="region-panel__fact-value">{currentAction || 'IDLE'}</span>
        </div>
        {enemyLevelRange ? (
          <div className="region-panel__fact">
            <span className="region-panel__fact-label">Enemy levels</span>
            <span className="region-panel__fact-value">{enemyLevelRange}</span>
          </div>
        ) : null}
        <div className="region-panel__fact">
          <span className="region-panel__fact-label">Threat</span>
          <span className="region-panel__fact-value">{threat}</span>
        </div>
        {regionalRegen ? (
          <div className="region-panel__fact">
            <span className="region-panel__fact-label">Regional HP regen</span>
            <span className="region-panel__fact-value">{regionalRegen}</span>
          </div>
        ) : null}
      </div>
    </div>
  );
}

const RegionPanel = React.memo(RegionPanelComponent);

export default RegionPanel;
